<template>
  <!-- 横排的前三名 -->
  <div
    v-if="type === 'vertical'"
    :class="['rank-item vertical', 'number-' + formatList.displayRank]"
  >
    <p :class="['serial-number', 'number-' + formatList.displayRank]">
      <!-- {{ formatList.displayRank | fixNumber }} -->
      <img
        class="number"
        :src="
          require(`@/assets/images/activities/ranking/${formatList.rank}.png`)
        "
      />
    </p>
    <p class="nickName">{{ formatList.userName || 'Toplupe User' }}</p>
    <div
      :class="['like-handle', 'number-' + formatList.displayRank]"
      v-if="!formatList.isMyself"
    >
      <div class="img-wrapper" v-if="likeAnimationFinished">
        <img
          class="icon"
          v-if="formatList.liked"
          :src="formatList.icon"
          ref="likeIconRef"
          @click="handleLike(formatList)"
        />
        <img
          class="icon"
          v-else
          :src="formatList.icon"
          @click="handleLike(formatList)"
          ref="likeIconRef"
        />
      </div>
      <LikeAnimation
        size="small"
        ref="likeAnimationRef"
        @animationComplete="animationComplete"
      />
      <p class="tips">{{ $t('ranking.like') }}</p>
    </div>
    <div class="like-handle placeholder-wrapper" v-else></div>
    <div :class="['handle-number', 'number-' + formatList.displayRank]">
      <p class="start">
        <img
          class="icon"
          :src="require(`@/assets/images/activities/ranking/start.png`)"
        />
        <span class="number">{{ formatList.points_format }}</span>
      </p>
      <p class="like">
        <img
          class="icon"
          :src="require(`@/assets/images/activities/ranking/like.png`)"
        />
        <span class="number">{{ formatList.belikeCount_format }}</span>
      </p>
    </div>

    <div
      class="awards-wrapper"
      v-if="formatList && formatList.coupon && formatList.coupon.id"
    >
      <CouponCard :list="formatList" />
    </div>
  </div>
  <!-- 竖排的第三名之后的 -->
  <div v-else class="rank-item horizontal" :style="getBgColor">
    <div class="left-wrapper">
      <p class="serial-number" :class="region">
        <i18n path="ranking.xth" tag="span">
          <span place="rankingNum" class="rankingNum"
            >{{ formatList.rank | fixNumber }}&nbsp;</span
          >
        </i18n>
      </p>
      <div
        class="awards-wrapper"
        v-if="formatList && formatList.coupon && formatList.coupon.id"
      >
        <CouponCard :list="formatList" />
      </div>
    </div>
    <div class="avatar-image-wrapper">
      <CommonAvatar
        :hasCrown="false"
        :hasBorder="false"
        size="small"
        :url="formatList.avatarUrl"
      />
    </div>
    <div class="middle-wrapper">
      <div class="nickName">{{ formatList.userName || 'Toplupe User' }}</div>
      <div class="handle-wrapper">
        <p class="start">
          <img
            class="icon"
            :src="require(`@/assets/images/activities/ranking/start.png`)"
          />
          <span class="number">{{ formatList.points_format }}</span>
        </p>
        <p class="like">
          <img
            class="icon"
            :src="require(`@/assets/images/activities/ranking/like.png`)"
          />
          <span class="number">{{ formatList.belikeCount_format }}</span>
          <AddOne v-if="showAddOne" />
        </p>
      </div>
    </div>
    <div class="right-wrapper">
      <template v-if="formatList.isMyself">
        <button class="topUp-btn" @click="topup">
          {{
            loginStatus ? $t('ranking.recharge_points') : $t('ranking.log_in')
          }}
        </button>
      </template>
      <template v-else>
        <div class="img-wrapper" v-if="likeAnimationFinished">
          <img
            class="icon"
            v-if="formatList.liked"
            :src="formatList.icon"
            ref="likeIconRef"
            @click="handleLike(formatList)"
          />
          <img
            class="icon"
            v-else
            :src="formatList.icon"
            @click="handleLike(formatList)"
            ref="likeIconRef"
          />
        </div>
        <LikeAnimation
          ref="likeAnimationRef"
          @animationComplete="animationComplete"
        />
        <p class="tips">{{ $t('ranking.like') }}</p>
      </template>
    </div>
  </div>
</template>
<script>
  import CommonAvatar from '../Avatar'
  import LikeAnimation from '../LikeAnimation'
  import { getAcitivityInfo } from '../../helper'
  import { mapState } from 'vuex'
  import CouponCard from './CouponCard'
  import AddOne from '../AddOne'
  import { textFormat } from '@/utils/pluralRules.js'

  export default {
    components: {
      CommonAvatar,
      LikeAnimation,
      CouponCard,
      AddOne,
    },
    props: {
      type: {
        type: String,
        default: '',
      },
      list: {
        type: Object,
        default: () => {},
      },
      index: {
        type: Number,
        default: 0,
      },
      isOwner: {
        type: Boolean,
        default: false,
      },
      todayMaxCancelNum: {
        type: Number,
        default: 0,
      },
      todayMaxNumByLike: {
        type: Number,
        default: 0,
      },
      myselfMaxNumByLike: {
        type: Number,
        default: 0,
      },
      myselfInRankingInfo: {
        type: Object,
        default: () => {},
      },
    },
    filters: {
      fixNumber(num) {
        // if (num < 10) {
        //   return `0${num}`
        // }
        return num
      },
    },
    computed: {
      ...mapState(['userInfo', 'region']),
      formatList() {
        const res = this.list
        const unlikeIcon = require(`@/assets/images/activities/ranking/unlike.png`)
        const likeIcon = require(`@/assets/images/activities/ranking/like.png`)
        res.icon = res.liked ? likeIcon : unlikeIcon
        return res
      },
      getBgColor() {
        const { index } = this
        const colorMaps = {
          1: {
            background:
              'linear-gradient(270.79deg, rgba(255, 248, 252, 0.57) -3.35%, #FFEBF6 53.28%, rgba(255, 235, 245, 0.56) 102.22%)',
          },
          2: {
            background:
              'linear-gradient(270.79deg, rgba(220, 228, 255, 0.24) -7.53%, #E9EEFF 52.69%, rgba(239, 243, 255, 0.24) 105.83%)',
          },
          0: {
            background:
              'linear-gradient(270deg, #FFFBEF 0%, #FFF6E0 50%, #FFFEFD 99.99%, #FFFFFF 100%, #E5E5E5 100%)',
          },
        }
        return colorMaps[index % 3]
      },
      loginStatus() {
        const { kicoinId, kicoinToken } = this.userInfo || {}
        if (kicoinId && kicoinToken) {
          return true
        }
        return false
      },
      // 活动是否已结束
      activityIsEnded() {
        const { activityInfos = {} } = this
        // 活动状态 1待激活 2已激活 3已停止 4已下线
        // const { activityStatus = 0 } = activityInfos
        // return activityStatus * 1 === 3
        const { extraInfo = {} } = activityInfos
        // computeStartTime 积分计算开始时间
        const { computeEndTime } = extraInfo
        const currentTs = +new Date() / 1000
        return currentTs > computeEndTime
      },
    },
    data() {
      return {
        likeAnimationFinished: true,
        selectedList: null,
        awardRelationInfo: [],
        showAddOne: false,
        activityInfos: {},
        textFormat: textFormat,
      }
    },
    mounted() {
      getAcitivityInfo().then((res = {}) => {
        this.activityInfos = res
        const { extraInfo = {} } = res
        this.awardRelationInfo = extraInfo.awardRelationList[0] || {}
      })
    },
    methods: {
      handleLike(list) {
        if (this.activityIsEnded) {
          return
        }
        const {
          userInfo = {},
          todayMaxNumByLike,
          myselfMaxNumByLike,
          myselfInRankingInfo,
        } = this
        const { belikeCount = 0 } = myselfInRankingInfo || {}
        if (
          !list.liked &&
          userInfo &&
          userInfo.kicoinId &&
          todayMaxNumByLike > 0 &&
          myselfMaxNumByLike > belikeCount
        ) {
          this.likeAnimationFinished = false
          this.showAddOne = true
          this.$refs.likeAnimationRef.play()
        }
        this.$emit('likeHandle', list)
      },
      animationComplete() {
        this.likeAnimationFinished = true
        this.showAddOne = false
      },
      topup() {
        this.$emit('topup')
      },
    },
  }
</script>
<style lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
